<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Assign Accounting Entry</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AssignEntriesForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import AssignEntriesForm from "../../../components/Kleyton/Forms/Product/AccountingEntry/AssignEntriesForm";

export default {
  name: "AssignAccountingEntry",
  page: {
    title: "Assign Accounting Entry",
    meta: [{ name: "Assign Accounting Entry", content: window.__env.app.description }]
  },
  components: {
    AssignEntriesForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "AssignAccountingEntry",
      title: "Assign Accounting Entry",
      items: [
        {
          text: "Product",
          href: "/"
        },
        {
          text: "Assign Accounting Entry",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
